import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PageContainer from "../../components/PageContainer/PageContainer";
import { URLs } from "../../utils/redirectStep";
import { getSessionDocument } from "services/sessionStorageService";

function PagoPendiente() {
  const navigate = useNavigate();
  const location = useLocation();

  const nroTelefono = window.nroTelefono;
  const messagePending =
    location.state?.messagePending ||
    `<p className={classes.modalMessage}><span style="color: #d00771!important">¡El pago se encuentra pendiente!</span><br /><br />Por consultas comunicarse<br />al <span class="special-font">${nroTelefono}</span><br /><br />¡Muchas gracias!</p>`;

  const modal = {
    open: true,
    showX: true,
    message: messagePending,
  };

  useEffect(() => {
    const documento = getSessionDocument();
    if (!documento) {
      navigate(URLs.home);
    }
  }, []);

  const handleModalCloseClick = () => {
    window.location.href = "https://italmundo.com.uy/";
  };

  return (
    <PageContainer
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.pagoPendiente}
      noImage={true}
    />
  );
}

export default PagoPendiente;
